import React from "react";
import {
    AccreditationTypeListProps,
    SelectableTypes,
} from "./AccreditationTypeList.types";
import { useForm } from "react-hook-form";

const AccreditationTypeList = (props: AccreditationTypeListProps) => {
    const { handleSubmit, register, reset, setValue } = useForm<number[]>();

    const onSubmit = (formData) => {
        console.log(formData);
        props.onSubmit([+formData.accreditationTypes]);
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            {SelectableTypes.map((selectable) => (
                <div className="form-group" key={selectable.value}>
                    <div>
                        <label htmlFor={`type[${selectable.value}]`}>
                            {selectable.name}
                        </label>
                    </div>
                    <div>
                        <label className="radio-container">
                            <input
                                type="radio"
                                name="accreditationTypes"
                                ref={register()}
                                value={selectable.value}
                                defaultChecked={
                                    props.selectedAccreditationTypes.indexOf(
                                        selectable.value
                                    ) >= 0
                                }
                            />
                            <span className="radio-styled"></span>
                        </label>
                    </div>
                </div>
            ))}
            <div className="button-footer">
                <div style={{ margin: "0 auto" }}>
                    <button type="submit" className="submit-btn">
                        Search
                    </button>
                </div>
            </div>
        </form>
    );
};

export default AccreditationTypeList;
